import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetVoucherData } from '../types';

export const GET_VOUCHER: TypedDocumentNode<IGetVoucherData> = gql`
  query getVoucher {
    viewer {
      site {
        id
        voucher {
          id
          updated
          voucherSubmittedBy {
            id
            lastName
            firstName
            role
            username
          }
          voucherSubmissionStatus
          voucherRoomDetail {
            title
            roomId
            groupType
            testTakerCounts {
              absent
              deniedEntry
              registered
            }
            staff {
              id
              role
              voucherRole
              firstName
              lastName
            }
          }
          voucherUnassignedStaffDetail {
            id
            role
            voucherRole
            groupType
            needsTokenPayment
            firstName
            lastName
          }
          voucherExpense
        }
      }
    }
  }
`;
